<template>
  <div class="d-flex">
    <button v-bind="attributesBinding" v-if="currentField.isType == 'BOX'" />
    <h4
      v-bind="attributesBinding"
      v-else
      class="text-center px-2"
      :class="{
        'rounded-circle': currentField.isType == 'CIRCLE',
        underline: currentField.isType == 'UNDERLINE',
      }"
    >
      {{ valueText }}
    </h4>
  </div>
</template>


<script>
export default {
  name: "FormElementStructure",
  store: ["mainExpression"],
  props: ["currentField"],
  computed: {
    attributesBinding() {
      var attr = {
        style: { "min-width": this.widthUnderline },
      };
      const { currentField } = this;
      if (currentField.id) {
        attr.id = `FormElementStructure-${currentField.id}`;
      }
      if (currentField.color) {
        attr.style = {
          ...attr.style,
          color:
            currentField.isType == "TEXT" || currentField.isType == "UNDERLINE"
              ? currentField.color
              : null,
        };
      }
      if (currentField.isType == "BOX") {
        attr.style = {
          ...attr.style,
          border: `2px solid ${currentField.color}`,
        };
      }
      return attr;
    },
    valueText() {
      const { isType, value, text } = this.currentField;
      if (isType !== "UNDERLINE" && value.ja) {
        return value.ja;
      } else if (isType != "UNDERLINE" && !value.ja) {
        return text;
      } else if (isType == "UNDERLINE") {
        return value.ja;
      }
      return "";
    },
    widthUnderline() {
      const { isType, width } = this.currentField;
      if (isType == "UNDERLINE") {
        return `${width}rem`;
      }
      return null;
    },
  },
};
</script>
<style scoped>
::v-deep .v-input__slot {
  min-height: 30px !important;
}
h4 {
  user-select: none;
}
button {
  height: 26px;
  background-color: white;
  width: 80px;
  border-radius: 4px;
}
button:focus {
  outline: none;
}
.underline {
  border-bottom: 2px solid #cccccc;
  height: 26px;
}
.underline--bacon {
  background-image: linear-gradient(
      45deg,
      transparent 65%,
      #8a8a8a 80%,
      transparent 90%
    ),
    linear-gradient(135deg, transparent 5%, #8a8a8a 15%, transparent 25%),
    linear-gradient(135deg, transparent 45%, #8a8a8a 55%, transparent 65%),
    linear-gradient(45deg, transparent 25%, #8a8a8a 35%, transparent 50%);
  background-repeat: repeat-x;
  background-size: 12px 3px;
  background-position: 0 90%;
}
</style>
